module.exports = __webpack_public_path__ + "static/media/cyclohexane.52463b91.svg";